<template>
  <div class="page flex-col">

    <div class="group_2 flex-col">
      <div class="block_1 flex-col">
        <div class="image-wrapper_1 flex-row">
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG7ba570a83befcbe064b13fb9d24088c8.png'"
          />
          <img
            class="image_3"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG6a94e3f80b0a881a2f82b16ad3e3a8f8.png'"
          />
         
          <div style="margin-left: -32vw;"> <headerMask/> </div>
        </div>
      </div>
      <div class="text-group_1 flex-col justify-between">
        <span class="text_2">以动健康产品价格</span>
        <span class="text_3">专业、透明、可预约、可定制</span>
      </div>
    </div>
    <div class="group_3 flex-col">
      <div class="text-wrapper_1 flex-row"><span class="text_4">免费试用，找到适合你的版本</span></div>
      <div class="group_4 flex-row">
        <div class="box_w1 flex-row">
          <span @click="toPage('quotation_1')" class="text_5">个人版</span>
          <span @click="toPage('quotation_2')" class="text_6">便携工作站</span>
          <div class="text-wrapper_2 flex-col"><span class="text_7">旗舰工作站</span></div>
        </div>
      </div>
      <div class="group_5 flex-row">
        <div class="block_2 flex-col">
          <span class="text_8">价格咨询</span>
          <span class="text_9">手机：13220190868</span>
          <span class="text_10">邮箱：info&#64;ktangtang.com</span>
          <div @click="toTools" style="cursor: pointer;" class="text-wrapper_3 flex-col"><span class="text_11">查看详情</span></div>
          <span class="text_12">适用于大型医院，康养地产</span>
          <div class="image-text_1 flex-row justify-between">
            <img
              class="thumbnail_3"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_2">3000+高清带解析的运动视频及分解图</span>
          </div>
          <div class="image-text_2 flex-row justify-between">
            <img
              class="thumbnail_4"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_3">50余种疾病，涵盖骨科慢性疼痛，术后康复，三高慢性病等的运动康复计划</span>
          </div>
          <div class="image-text_3 flex-row justify-between">
            <img
              class="thumbnail_5"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_4">70余种肌肉群组的运动方式</span>
          </div>
          <div class="image-text_4 flex-row justify-between">
            <img
              class="thumbnail_6"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_5">200余种骨科康复特殊评估实验</span>
          </div>
          <div class="image-text_5 flex-row justify-between">
            <img
              class="thumbnail_7"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_6">发送问卷功能</span>
          </div>
          <div class="image-text_6 flex-row justify-between">
            <img
              class="thumbnail_8"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_7">公共模板节省时间学习运动处方</span>
          </div>
          <div class="image-text_7 flex-row justify-between">
            <img
              class="thumbnail_9"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_8">个人模板创建自己的运动康复模板</span>
          </div>
          <div class="image-text_8 flex-row justify-between">
            <img
              class="thumbnail_10"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_9">无限量的运动计划</span>
          </div>
          <div class="image-text_9 flex-row justify-between">
            <img
              class="thumbnail_11"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_10">无限的病人数量</span>
          </div>
          <div class="image-text_10 flex-row justify-between">
            <img
              class="thumbnail_12"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_11">免费的患者端小程序应用：以动Rehab</span>
          </div>
          <div class="image-text_11 flex-row justify-between">
            <img
              class="thumbnail_13"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_12">显示机构/治疗师名字的视频及打印版处方</span>
          </div>
          <div class="image-text_12 flex-row justify-between">
            <img
              class="thumbnail_14"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_13">免费在线培训课程</span>
          </div>
          <div class="image-text_13 flex-row justify-between">
            <img
              class="thumbnail_15"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_14">每周7天的客服支持</span>
          </div>
          <div class="image-text_14 flex-row justify-between">
            <img
              class="thumbnail_16"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNGdb9397dc5aeb8376677f53d03050f01e.png'"
            />
            <span class="text-group_15">可以对接到常用的诊所，医院系统</span>
          </div>
          <div class="image-text_15 flex-row justify-between">
            <img
              class="thumbnail_17"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNGdb9397dc5aeb8376677f53d03050f01e.png'"
            />
            <span class="text-group_16">专属客服对接</span>
          </div>
          <div class="image-text_16 flex-row justify-between">
            <img
              class="thumbnail_18"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNGdb9397dc5aeb8376677f53d03050f01e.png'"
            />
            <span class="text-group_17">管理旗下医生的超级账户</span>
          </div>
          <div class="image-text_17 flex-row justify-between">
            <img
              class="thumbnail_19"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNGdb9397dc5aeb8376677f53d03050f01e.png'"
            />
            <span class="text-group_18">定制logo</span>
          </div>
          <div class="image-text_18 flex-row justify-between">
            <img
              class="thumbnail_20"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNGdb9397dc5aeb8376677f53d03050f01e.png'"
            />
            <span class="text-group_19">定制问卷内容（限制3份，后续自主上传）</span>
          </div>
          <div class="image-text_19 flex-row justify-between">
            <img
              class="thumbnail_21"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNGdb9397dc5aeb8376677f53d03050f01e.png'"
            />
            <span class="text-group_20">定制运动处方计划（限制三份待定）</span>
          </div>
          <div class="image-text_20 flex-row justify-between">
            <img
              class="thumbnail_22"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNGdb9397dc5aeb8376677f53d03050f01e.png'"
            />
            <span class="text-group_21">自动发送问卷及运动处方给患者（可根据需要进行定制开发1套）</span>
          </div>
          <div class="image-text_21 flex-row justify-between">
            <img
              class="thumbnail_23"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNGdb9397dc5aeb8376677f53d03050f01e.png'"
            />
            <span class="text-group_22">物联网硬件管理，收集操作物联网设备</span>
          </div>
          <div class="image-text_22 flex-row justify-between">
            <img
              class="thumbnail_24"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNGdb9397dc5aeb8376677f53d03050f01e.png'"
            />
            <span class="text-group_23">通用医疗运动处方工作站一台</span>
          </div>
          <div class="group_6 flex-col">
            <div class="box_2 flex-col"></div>
            <div class="box_3 flex-col"></div>
          </div>
          <div class="group_7 flex-col"></div>
          <div class="group_8 flex-col"></div>
        </div>
      </div>
      <div class="group_9 flex-row">
        <div class="section_1 flex-col"></div>
        <img
          class="thumbnail_25"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/f724872cc05e4dfb9870411fd76c27e8_mergeImage.png'"
        />
        <div class="image-text_23 flex-row justify-between">
          <div class="group_10 flex-col">
            <div class="group_11 flex-col"></div>
            <span class="text-group_24">使用机构</span>
          </div>
          <div class="image-wrapper_2 flex-col">
            <img
              class="thumbnail_26"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
      <div class="group_12 flex-row">
        <div class="image-text_24 flex-col justify-between">
          <div class="image-wrapper_3 flex-col">
            <img
              class="image_4"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG2fbf7c11805554d73e846b7b0f4b3aef.png'"
            />
          </div>
          <span class="text-group_25">南方医科大</span>
        </div>
        <div class="image-text_25 flex-col justify-between">
          <img
            class="image_5"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG21013959cf5c79221306a6b3327b8268.png'"
          />
          <span class="text-group_26">北京大学人民医院</span>
        </div>
        <div class="image-text_26 flex-col justify-between">
          <img
            class="image_6"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNGf2dc5ad3f281e8a1a20076881a8799f1.png'"
          />
          <span class="text-group_27">
            首都医科大学附属
            <br />
            北京安定医院
          </span>
        </div>
      </div>
      <div class="group_13 flex-row">
        <div class="image-text_27 flex-col justify-between">
          <img
            class="image_7"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNGa92464ac282f88ef7ba4f01d489efad9.png'"
          />
          <span class="text-group_28">
            首都医科大学
            <br />
            北京朝阳医院
          </span>
        </div>
        <div class="image-text_28 flex-col justify-between">
          <img
            class="image_8"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG4134d4fe9f042276b09cea826acf1d45.png'"
          />
          <span class="text-group_29">中日友好医院</span>
        </div>
        <div class="box_4 flex-col justify-between">
          <div class="block_3 flex-col">
            <div class="image-wrapper_4 flex-col">
              <img
                class="image_9"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNGc2fc5c98241879f8c9a0d9271c01c855.png'"
              />
            </div>
          </div>
          <span class="paragraph_1">
            北京医院
            <br />
            （国家老年医学中心）
          </span>
        </div>
      </div>
      <div class="group_14 flex-row">
        <div class="group_15 flex-col"></div>
        <img
          class="thumbnail_27"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/448d3779be804a0eab0bf91b3125e8a3_mergeImage.png'"
        />
        <div class="image-text_29 flex-row justify-between">
          <div class="box_5 flex-col">
            <div class="section_2 flex-col"></div>
            <span class="text-group_30">典型项目案例展示</span>
          </div>
          <div class="image-wrapper_5 flex-col">
            <img
              class="thumbnail_28"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
      <div class="image-wrapper_6 flex-row">
        <img
          class="thumbnail_29"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG075ce7ed400dc9c1683ddc509a884e1f.png'"
        />
        <img
          class="image_10"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG92865307e079109c55ce86e1a50a1141.png'"
        />
        <img
          class="image_11"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNGca4d46e6bebd85a82a4edb60bf79b4c7.png'"
        />
        <img
          class="image_12"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG28fb40480630188a21cbd8883956b251.png'"
        />
        <img
          class="image_13"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG56e86d642286fcd631d21b2fd4692a6f.png'"
        />
        <img
          class="image_14"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG6e983b5e2471ed1c5f7024c22ef5c273.png'"
        />
        <img
          class="image_15"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG0d9ad919e9d0142ef3225f57cb9238ca.png'"
        />
        <img
          class="thumbnail_30"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG7b1d2039782e29ca05547eeefe55996a.png'"
        />
      </div>
      <div class="group_16 flex-row">
        <span class="text_13">旗舰工作站</span>
        <div class="group_17 flex-col"></div>
      </div>
      <div class="group_18 flex-col"></div>
      <img
        class="image_16"
        referrerpolicy="no-referrer"
        v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG6e0cd639397bd331938b9db13c90f0f5.png'"
      />
    </div>
    <div class="group_19 flex-col">
      <div class="text-group_31 flex-col justify-between">
        <span class="text_14">联系方式</span>
        <span class="text_15">contact&nbsp;information</span>
      </div>
      <div class="text-group_32 flex-col justify-between">
        <span class="text_16">132-2019-0868</span>
        <span class="text_17">北京市顺义区中关村科技园区顺义园汇海中路7号院221-03室</span>
      </div>
      <div class="text-group_33 flex-col justify-between">
        <span class="text_18">info&#64;ktangtang.com</span>
        <span class="text_19">https://ktangtang.com</span>
      </div>
    </div>
    <footerMask/>
    <img
      class="image_19"
      referrerpolicy="no-referrer"
      v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG36f687d7a1e324e88c0e7a2e52d37b75.png'"
    />
  </div>
</template>
<script>
import headerMask from "../../components/headery";
import footerMask from "../../components/footert";

export default {
  components: {
    headerMask,
    footerMask
  },
  data() {
    return {
      constants: {}
    };
  },
  methods: {
    toTools(){
          window.location.href=  'https://yd-tool.ktangtang.com/login'
    },
    toPage(e){
      this.$router.push({path: e})
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.response.css" />